import * as React from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {Button, Container, Divider, Step, StepLabel, Stepper} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import NavigationBar from "../../../../components/NavigationBar";
import HomeIcon from '@mui/icons-material/Home';
import {useNavigate} from "react-router-dom";
import {RoutePath} from "../../../../constants/RoutePath";
import RegisterVisitForm from "../visitor/components/RegisterVisitForm";
import {VisitRequestDto} from "../../../../modules/vms/dto/VisitRequestDto";
import {ApplySourceType} from "../../../../modules/vms/enums/ApplySourceType";
import {VisitRequestClassify} from "../../../../modules/vms/enums/VisitRequestClassify";
import dayjs from "dayjs";
import {Formats} from "../../../../constants/Formats";
import {RequestVisitorDto} from "../../../../modules/vms/dto/RequestVisitorDto";
import RegisterVisitorForm from "../visitor/components/RegisterVisitorForm";
import RegisterNoticeDialog from "../visitor/components/RegisterNoticeDialog";
import RegisterTrainingForm from "../visitor/components/RegisterTrainingForm";
import RegisterFinishForm from "../visitor/components/RegisterFinishForm";
import {RequestVisitorApi} from "../../../../modules/vms/api/RequestVisitorApi";
import {HttpStatus} from "../../../../modules/common/enums/HttpStatus";
import {MessageUtils} from "../../../../utils/MessageUtils";
import {WeChatAuthApi} from "../../../../modules/wechat/api/WeChatAuthApi";
import {HttpUtils} from "../../../../utils/HttpUtils";
import {DepartmentApi} from "../../../../modules/account/api/DepartmentApi";
import {DepartmentDto} from "../../../../modules/account/dto/DepartmentDto";

export default function Index() {

    const intl = useIntl();
    const navigate = useNavigate();
    const [openNoticeDialog, setOpenNoticeDialog] = useState(true);
    const [visitRequest, setVisitRequest] = useState(new VisitRequestDto());
    const [requestVisitor, setRequestVisitor] = useState<RequestVisitorDto>(new RequestVisitorDto());
    const [stepIndex, setStepIndex] = useState(0);
    const [skipTrainingStep, setSkipTrainingStep] = useState(false);
    const [wechatOpenId, setWechatOpenId] = useState("");

    useEffect(() => {
        _handleInit();

    }, []);


    const _handleInit = () => {

        // 微信网页授权会携带code，然后通过后台获取openID，提交的时候把该openID跟访客绑定
        const wxOAuthCode = HttpUtils.getQueryString(window.location.href, "wxOAuthCode");
        if (wxOAuthCode) {
            _handleGetWeChatOpenId(wxOAuthCode);
        }


    };
    const _handleInitRequest = async (wxOpenId:string) => {
        const responseResult = await RequestVisitorApi.getLastVisitorInfoByWeOpenId(wxOpenId);
        if (responseResult.status === HttpStatus.SUCCESS) {
            if (responseResult.data == null) {
                const newVisitRequest = new VisitRequestDto();
                newVisitRequest.applySourceType = ApplySourceType.Enum.VisitorMobileWeb;
                newVisitRequest.classify = VisitRequestClassify.Enum.Visitor;
                newVisitRequest.arriveStartDate = dayjs().format(Formats.DATE_SIMPLE);
                newVisitRequest.arriveEndDate = newVisitRequest.arriveStartDate;
                newVisitRequest.arriveStartTime = '000000';
                newVisitRequest.arriveEndTime = '235959';
                setVisitRequest(newVisitRequest);
                setRequestVisitor(new RequestVisitorDto())

            } else {
                const data = responseResult.data;
                let requestVisitorDto = new RequestVisitorDto();
                requestVisitorDto.idType = data.idType;
                requestVisitorDto.remarks = data.remarks;
                requestVisitorDto.idNumber = data.idNumber;
                requestVisitorDto.mobile = data.mobile;
                requestVisitorDto.lastName = data.lastName;
                requestVisitorDto.firstName = data.firstName;
                requestVisitorDto.company = data.company;
                requestVisitorDto.email = data.email;
                requestVisitorDto.driveType = data.driveType;
                requestVisitorDto.plateNumber = data.plateNumber;
                setRequestVisitor(requestVisitorDto);

                const newVisitRequest = new VisitRequestDto();
                newVisitRequest.applySourceType = ApplySourceType.Enum.VisitorMobileWeb;
                newVisitRequest.classify = VisitRequestClassify.Enum.Visitor;
                newVisitRequest.arriveStartDate = dayjs().format(Formats.DATE_SIMPLE);
                newVisitRequest.arriveEndDate = newVisitRequest.arriveStartDate;
                newVisitRequest.arriveStartTime = '000000';
                newVisitRequest.arriveEndTime = '235959';
//                 newVisitRequest.hostFullName = data.visitRequest.hostFullName;
//                 newVisitRequest.hostUserId = data.visitRequest.hostUserId;
//                 newVisitRequest.hostDepartmentId = data.visitRequest.hostDepartmentId;
//                 newVisitRequest.hostMobile = data.visitRequest.hostMobile;
//                 newVisitRequest.hostDepartmentName = data.visitRequest.hostDepartmentName;
//
//                 newVisitRequest.purpose = data.visitRequest.purpose;
//
//                 newVisitRequest.places = data.visitRequest.places;
//                 newVisitRequest.transportGoods = data.visitRequest.transportGoods;
//                 newVisitRequest.personalGoodsDescription = data.visitRequest.personalGoodsDescription;
// console.log(newVisitRequest)
                setVisitRequest(newVisitRequest);

            }
        }
    }
    const _handleGetWeChatOpenId = async (wxOAuthCode: string) => {
        const responseResult = await WeChatAuthApi.getOAuth2AccessToken(wxOAuthCode);
        if (responseResult.status === HttpStatus.SUCCESS) {
            console.log(responseResult.data);
            setWechatOpenId(responseResult.data.openid);
            _handleInitRequest(responseResult.data.openid);
        }
    }

    const stepTitles = new Array<string>();
    stepTitles.push(intl.formatMessage({id: 'VMS_VISIT_REQUEST_REGISTER_STEP_HOST_INFO'}));
    stepTitles.push(intl.formatMessage({id: 'VMS_VISIT_REQUEST_REGISTER_STEP_VISITOR_INFO'}));
    stepTitles.push(intl.formatMessage({id: 'VMS_VISIT_REQUEST_REGISTER_STEP_TRAINING'}));
    stepTitles.push(intl.formatMessage({id: 'VMS_VISIT_REQUEST_REGISTER_STEP_SUBMIT'}));

    const stepForms = new Array<JSX.Element>();
    const registerVisitForm = <RegisterVisitForm visitRequest={visitRequest} onNext={(visitRequest) => {
        setVisitRequest(visitRequest);
        setStepIndex(stepIndex + 1);
    }}/>;
    const registerVisitorForm = <RegisterVisitorForm fromEmployeeRegisterFlg={true} requestVisitor={requestVisitor} onPrevious={() => {
        setStepIndex(stepIndex - 1);
    }} onNext={(requestVisitor) => {
        requestVisitor.wxOpenId = wechatOpenId;
        setRequestVisitor(requestVisitor);
        _checkVisitorLastTrainingDate(requestVisitor);
    }}/>;
    const registerTrainingForm = <RegisterTrainingForm onPrevious={() => {
        setStepIndex(stepIndex - 1);
    }} onNext={() => {
        const newRequestVisitor = {...requestVisitor};
        newRequestVisitor.lastTrainingDate = dayjs().format(Formats.DATE_SIMPLE);
        setRequestVisitor(newRequestVisitor);
        setStepIndex(stepIndex + 1);
    }}/>;
    const registerFinishForm = <RegisterFinishForm fromEmployeeRegisterFlg={true} visitRequest={visitRequest}
                                                   requestVisitor={requestVisitor}
                                                   onPrevious={() => {
                                                       if (skipTrainingStep) {
                                                           setStepIndex(stepIndex - 2);
                                                       } else {
                                                           setStepIndex(stepIndex - 1);
                                                       }
                                                   }}/>;
    stepForms.push(registerVisitForm);
    stepForms.push(registerVisitorForm);
    stepForms.push(registerTrainingForm);
    stepForms.push(registerFinishForm);

    const _checkVisitorLastTrainingDate = async (requestVisitor: RequestVisitorDto) => {
        const responseResult = await RequestVisitorApi.checkLastTrainingDate(requestVisitor);
        if (responseResult.status === HttpStatus.SUCCESS) {
            if (responseResult.data === true) {
                MessageUtils.warning(intl.formatMessage({id: "VMS_REQUEST_VISITOR_TRAINING_SKIP"}));
                setStepIndex(stepIndex + 2);
                setSkipTrainingStep(true);
            } else {
                setSkipTrainingStep(false);
                setStepIndex(stepIndex + 1);
            }
        }
    };

    return (
        <div>
            <RegisterNoticeDialog open={openNoticeDialog} onClose={() => setOpenNoticeDialog(false)}/>
            <NavigationBar leftIcon={<HomeIcon/>}
                           leftIconClick={() => navigate(RoutePath.VMS_MOBILE_WELCOME)}
                           title={intl.formatMessage({id: "VMS_MOBILE_WELCOME_EMPLOYEE_REGISTER"})}/>
            <br/>
            <Stepper activeStep={stepIndex} alternativeLabel>
                {stepTitles.map((item, index,) => (
                    <Step key={index}>
                        <StepLabel>{item}</StepLabel>
                    </Step>
                ))}
            </Stepper>
            <br/>
            <Container>
                {stepForms[stepIndex]}
            </Container>
            <br/>
        </div>
    )
}